<template>
  <div class="resources" id="resources" ref="resources"></div>
</template>

<script>
export default {
  props:['needData'],
  created(){
      
  },
  mounted() {
    // setTimeout(()=>{
    //   this.resources(this.needData); 
    // },200)
       this.resources(this.needData); 
  },
  // watch: {
  //   'needData'() {
  //     this.resources(this.needData);
  //   },
  // },
  methods: {
    resources(param) {
      let myEchart = this.$echarts.init(document.getElementById("resources"));

      // console.log(param,'param');
       let list = [
        {
          name: "CPU使用率",
          value: param.CPUrate,
        },
        {
          name: "内存使用率",
          value: param.Memoryrate,
        },
        {
          name: "磁盘空间使用率",
          value: param.Diskrate,
        },
      ];

      // console.log(list);

      let yName = list.map((item) => item.name);
      let xData = list.map((item) => item.value);
      let barWidth = 10;

       var option = {
        // color: colorList,
        xAxis: {
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        grid: {
          right: 90,
          top: 30,
          bottom: 10,
          left: 120,
        },
        yAxis: [
          {
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color: "#fff",
              },
            },
            data: yName,
          },
        ],
        series: [
          {
            //内
            type: "bar",
            barWidth,
            legendHoverLink: false,
            symbolRepeat: true,
            silent: true,
            itemStyle: {
              color: "#0ad0ef",
            },
            data: list,
            z: 1,
          },
          {
            // 背景
            type: "pictorialBar",
            animationDuration: 0,
            symbolRepeat: "fixed",
            symbolMargin: "20%",
            symbol: "roundRect",
            symbolSize: [barWidth, barWidth],
            itemStyle: {
              normal: {
                color: "#476274",
              },
            },
            label: {
              normal: {
                show: true,
                position: "right",
                offset: [0, 2],
                distance: 20,
                textStyle: {
                  color: "#7AF8FF",
                },
                formatter: function (params) {
                  return "{value|" + params.data + "}{unit|%}";
                },
                rich: {
                  value: {
                    fontSize: 12,
                    fontWeight: 600,
                  },
                  unit: {
                    padding: [0, 6],
                    fontSize: 12,
                  },
                },
              },
            },
            data: xData,
            z: 0,
          },
          {
            //分隔
            type: "pictorialBar",
            itemStyle: {
              color: "#000",
            },
            symbolRepeat: "fixed",
            symbolMargin: 6,
            symbol: "roundRect",
            symbolClip: true,
            symbolSize: [4, barWidth + 1],
            symbolPosition: "start",
            symbolOffset: [0, 0],
            data: list,
            z: 2,
          },
        ],
      };

      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>

<style scoped>
.resources {
    width: 100%;
    height: 100%;
}
</style>
